import $ from "jquery";

const relatedCardClicked = function () {
  $(this).find("a").click();
};

$(document).on("turbolinks:load", function () {
  if ($("#related-content").length == 0) {
    return;
  }

  $("#right-sidebar").on("click", ".related-card", relatedCardClicked);
});
